import { createWithEqualityFn } from 'zustand/traditional'
import { CastingStore } from 'types/store/castingStore'

const useStore = createWithEqualityFn<CastingStore>(
	(set) => ({
		sceneUploadContent: null,
		uploadedSceneContent: undefined,
		setSceneUploadContent: (content, uploaded) =>
			set({ sceneUploadContent: content, uploadedSceneContent: uploaded }),
		customCastingTabs: null,
		setCustomCastingTabs: (tabs) => set({ customCastingTabs: tabs }),
		openCastingChat: true,
		setOpenCastingChat: (open) => set({ openCastingChat: open }),
		openCastingRoles: true,
		setOpenCastingRoles: (open) => set({ openCastingRoles: open }),
		openReviewNdaSidebar: null,
		setOpenReviewNdaSidebar: (open) => set({ openReviewNdaSidebar: open }),
		chatContentId: '',
		setChatContentId: (id) => set({ chatContentId: id }),
		uploadedSceneIds: [],
		setUploadedSceneIds: (id, duration) =>
			set((state) => ({
				uploadedSceneIds: [...(state.uploadedSceneIds || []), { id, duration }],
			})),
		openCastingFeedbackSidebar: false,
		setOpenCastingFeedbackSidebar: (open) =>
			set({ openCastingFeedbackSidebar: open }),
		openSubmitCastingSidebar: false,
		setOpenSubmitCastingSidebar: (open) =>
			set({ openSubmitCastingSidebar: open }),
		openRejectNdaSidebar: false,
		setOpenRejectNdaSidebar: (open) => set({ openRejectNdaSidebar: open }),
		openRequestSidebar: null,
		setOpenRequestSidebar: (open) => set({ openRequestSidebar: open }),
		castingLoading: false,
		setCastingLoading: (loading) => set({ castingLoading: loading }),
		assignCastingRelation: null,
		setAssignCastingRelation: (relation) =>
			set({
				assignCastingRelation: relation,
			}),
		openCloseCastingSidebar: false,
		setOpenCloseCastingSidebar: (open) =>
			set({ openCloseCastingSidebar: open }),
		castingOverviewRedirectionLink: '',
		setCastingOverviewRedirectionLink: (link) =>
			set({ castingOverviewRedirectionLink: link }),
		tagsCount: {
			expiring: 0,
			castingClosed: 0,
			castingOpened: 0,
		},
		setTagsCount: (count) =>
			set((state) => ({ tagsCount: { ...state.tagsCount, ...count } })),
		contentData: {
			contentId: '',
			assetId: '',
		},
		setContentData: (data) =>
			set((state) => ({
				contentData: {
					...state.contentData,
					...data,
				},
			})),
		showTutorial: false,
		setShowTutorial: (show) => set({ showTutorial: show }),
		messageToChat: null,
		setMessageToChat: (message) => set({ messageToChat: message }),
		castingSubmitMessage: '',
		setCastingSubmitMessage: (message) =>
			set({ castingSubmitMessage: message }),
		collapsed: {
			candidates: true,
			roles: false,
			chat: false,
		},
		setCollapsed: (collapsed) => {
			const values: { [key: string]: boolean } = {}
			if (Object.keys(collapsed)[0] === 'roles') {
				values.roles = collapsed.roles as boolean
				values.candidates = !collapsed.roles as boolean
			}
			if (Object.keys(collapsed)[0] === 'candidates') {
				values.candidates = collapsed.candidates as boolean
				values.roles = !collapsed.candidates as boolean
			}

			set((state) => ({
				collapsed: {
					...state.collapsed,
					...values,
					...collapsed,
				},
			}))
		},
		projectAccess: undefined,
		setProjectAccess: (access) => set({ projectAccess: access }),
	}),
	Object.is,
)

export default useStore
